export const MONTHS = "month"
export const YEAR = "year"




export const MONTH_YEAR_STATUS = {
    [MONTHS]:  "MONTHS", 
    [YEAR]:  "YEARS",
    

}

  
export const monthYearUIhelper = (intl) => 
  Object.keys(MONTH_YEAR_STATUS).map((value) => ({
    value,
    label: intl.formatMessage({ id: MONTH_YEAR_STATUS[value] },),
  })) 
    
